<template>
  <div class="notices">
    <div class="notice_hear">
      <div style="margin-left: 28px">重要通知</div>
      <div @click="dianliebiao" class="shous" style="font-size: 19px; margin-right: 28px">
        更多
      </div>
    </div>
    <div class="noticeList">
      <div
        style="height;:90px"
        v-for="(item, index) in noticeList"
        :key="index"
      >
        <div class="notices_name">
          <div
            style=""
            class="dian"
            :class="item.status == 0 ? 'dian1' : 'dian2'"
          ></div>
          <div
            style="
              width: 66%;
              font-size: 18px;
              color: rgb(51, 51, 51);
              overflow: hidden;
              margin-left: 3%;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
          >
            {{ item.bidding_number }}
          </div>
          <div style="padding-left: 5%" class="notice_time">
            {{ item.bid_begin_time | dateFormats }}
          </div>
        </div>
        <div class="notices_details">{{ item.content }}</div>
      </div>
    </div>
    <div class="notices_footer">
      <div
        v-if="casd"
        @mouseover="checkout()"
        @click="goGuarantee()"
        class="notices_footer_box"
      >
        <div class="speed_img">
          <img src="../../assets/index/speed.png" />
        </div>
        <div class="speed_font">保函列表</div>
      </div>
      <div
        @click="goGuarantee()"
        @mouseleave="checkouts()"
        v-else
        class="notices_footer_boxs"
      >
        <div class="hear_name">
          <div class="shuxian" style="backgroundcolor: #41a4ff"></div>
          <div class="guarantees_name">保函列表</div>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-around;
            flex: 1;
            width: 100%;
          "
          class="content"
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              width: 47%;
              font-size: 16px;
              font-weight: 400;
            "
          >
            <div>审核中：{{ shenhe }}</div>
            <div>已拒绝：{{ jujue }}</div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              width: 47%;
              font-size: 16px;
              font-weight: 400;
            "
          >
            <div>已出函：{{ chuhan }}</div>
            <div>已过期：{{ guoqi }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="adas"
        @mouseover="scheckout()"
        @click="goProgress()"
        class="notices_footer_box"
      >
        <div class="speed_img">
          <img src="../../assets/index/status.png" />
        </div>
        <div class="speed_font1">发票列表</div>
      </div>
      <div
        @click="goProgress()"
        @mouseleave="scheckouts()"
        v-else
        class="notices_footer_boxs"
      >
        <div class="hear_name">
          <div class="shuxian" style="backgroundcolor: #41a4ff"></div>
          <div class="guarantees_name">发票列表</div>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-around;
            flex: 1;
            flex-direction: column;
            width: 100%;
          "
          class="content"
        >
          <div
            style="
              display: flex;
              justify-content: space-around;
              width: 100%;
              font-size: 16px;
              font-weight: 400;
            "
          >
            <div>待审核：{{ bhliste }}</div>
            <div>已出具：{{ bhlistes }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { daishen, wancheng, jujue, guoqi ,gongchenginfo} from "@/api/system/liucheng";
import { bhlist } from "@/api/system/liucheng";
export default {
  name: "Notice",
  data() {
    return {
      casd: true,
      adas: true,
      shenhe: "",
      jujue: "",
      chuhan: "",
      guoqi: "",
      shenhes: "",
      jujues: "",
      bhliste:"",
      bhlistes:"",
      params: {
        offset: 0,
        limit: 4,
        keywords: "",
        // user_id: sessionStorage.getItem("user_id"),
      },
          sparams: {
        page : 0,
        page_limit : 10,
        kws: "",
        fapiao_status:0,
        fplxdm:"",
        // user_id: sessionStorage.getItem("id"),
      },
            ssparams: {
        page : 0,
        page_limit : 10,
        kws: "",
        fapiao_status:1,
        fplxdm:"",
        // user_id: sessionStorage.getItem("id"),
      },
      noticeList: [
        {
          name: "南京城市的基础男的看看见是的呢",
          tiem: "2020-1-1",
          status: 1,
          details: "恶违法和厂房及对接输出接口连接件OK破皮卡皮卡的吗",
        },
        {
          name: "南京城市的基础男的看看见是的呢",
          tiem: "2020-1-1",
          status: 1,
          details: "恶违法和厂房及对接输出接口连接件OK破皮卡皮卡的吗",
        },
        {
          name: "南京城市的基础男的看看见是的呢",
          tiem: "2020-1-1",
          status: 0,
          details: "恶违法和厂房及对接输出接口连接件OK破皮卡皮卡的吗",
        },
      ],
    };
  },
  created() {
    this.getBhlist();
  },
  methods: {
    getBhlist() {
      daishen(this.params).then((res) => {
        // 
        //    shenhe:"",
        // jujue:"",
        // chuhan:"",
        // guoqi:"",
        // shenhes:"",
        // jujues:"",
        // this.BidingDocumentList = res.data.data.rows;
        this.shenhe = res.data.data.total;
      });
      wancheng(this.params).then((res) => {
        
        // this.BidingDocumentList = res.data.data.rows;
        this.chuhan = res.data.data.total;
      });
      jujue(this.params).then((res) => {
        
        // this.BidingDocumentList = res.data.data.rows;
        this.jujue = res.data.data.total;
      });
      guoqi(this.params).then((res) => {
        
        // this.BidingDocumentList = res.data.data.rows;
        this.guoqi = res.data.data.total;
      });
         gongchenginfo().then((res) => {
        //console.log("shuju",res.data.data.zhaobiao);
   this.noticeList=res.data.data.zhaobiao
      });
            bhlist(this.sparams).then((res) => {
        // //console.log("shuju",res.data.data.zhaobiao);
   this.bhliste=res.data.data.total
      });
                  bhlist(this.ssparams).then((res) => {
        // //console.log("shuju",res.data.data.zhaobiao);
   this.bhlistes=res.data.data.total
      });
    },
    checkout() {
      // //console.log("checkoutyishang");

      this.casd = false;
    },
    scheckout() {
      // //console.log("checkoutyishang");
      this.adas = false;
    },
    checkouts() {
      this.casd = true;
      // //console.log("checkoutsyichu");
    },
    scheckouts() {
      this.adas = true;
      // //console.log("checkoutsyichu");
    },
    goGuarantee() {
         this.$router.push({ name: "Guarantee" });
         return
          this.$confirm('是否打开保函列表?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
      
        }).catch(() => {        
        });
    
    },
    goProgress() {
          this.$router.push({ name: "/Navbars" });
            return
       this.$confirm('是否打开发票列表?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
         this.$router.push({ name: "/Navbars" });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
      // this.$router.push({ name: 'progress' })
      
    },
    dianliebiao() {
     
      this.$router.push({ name: "/sNavbar" });
    },
  },
};
</script>
<style scoped>
.btns {
  padding-left: 40%;
  /* position: relative;
  left: 57%; */
}
.hear_name {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}
.shuxian {
  width: 7px;
  height: 28px;
  background-color: #41a4ff;
  margin-left: 4px;
}
.guarantees_name {
  font-size: 20px;
  color: #333;
  margin-left: 10px;
  font-weight: Bold;
}
.speed_font {
  color: #ffffff;
  font-size: 18px;
  padding-top: 10px;
  /* position: relative;
    top: 49px;
    left: 103px; */
}

.speed_font1 {
  color: #ffffff;
  font-size: 18px;
  padding-top: 10px;
  /* position: relative;
    top: 49px;
    left: 87px; */
}

.speed_img {
  /* position: relative;
    top: 36px;
    left: 117px; */
}

.speed_img img {
  width: 50px;
  height: 44px;
}

.notices_footer_box {
  width: 49%;
  height: 144px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #1795ff;
}
.notices_footer_boxs {
  width: 49%;
  height: 144px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f6fa;
}
.notices_footer {
  display: flex;
  justify-content: space-between;
}

.notices_details {
  width: 100%;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 5%;
  color: #666666;
}

.notice_time {
  /* position: relative;
    left: 168px; */

  color: #666;
}

.notices_name {
  height: 60px;
  display: flex;
  align-items: center;
  /* justify-content: space-evenly; */
}

.dian {
  width: 7px;
  height: 7px;
  margin-left: 5%;
  border-radius: 180px;
}

.dian1 {
  background-color: #1795ff;
}

.dian2 {
  background-color: #ce0000;
}

.noticeList {
  width: 100%;
  height: 272px;
  background-color: #ffffff;
}

.notices {
  width: 50%;
  height: 475px;
  margin-right: 10px;
}

.notice_hear {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  background-color: #1795ff;
  color: #ffffff;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/view/index/Notice.vue